import {RunningTextService} from "@/services/runningtext.service";

const state = {
    dialog: false,
    loading: false,
    show: false,
    type: null,
    message: null,
    dialogutama: false,
    colordialog: 'indigo',
    judul: '',
    color: '',
    list: []
};


const actions = {
    OpenDialogForm({ commit }) {
        commit('opendialog');
    },
    closeDialog({ commit }) {
        commit('closedialog');
    },
    list({ commit }) {
        commit('setloading');
        commit('resetList');
        RunningTextService.list().then(data => {
            commit('addData', data);
        }, error => {
            console.log(error);
        });
    },
    Add({ dispatch, commit }, newData) {
        commit('setloading');
        RunningTextService.add(newData)
            .then(data => {
                dispatch('alert/success', data.msg, { root: true });
                commit('ShowAdd', data);
                RunningTextService.list().then(data => {
                    commit('addData', data);
                }, error => {
                    console.log(error);
                });
            }, error => {
                dispatch('alert/error', error, { root: true });
            })
    },
    Edit({ dispatch, commit }, editdata) {
        RunningTextService.edit(editdata)
            .then(data => {
                dispatch('alert/success', 'Edit data Successfully', { root: true });
                commit('ShowAdd', data);
            }, error => {
                dispatch('alert/error', error, { root: true });
            })
    },
    Delete({ dispatch, commit }, delete_id) {
        RunningTextService.hapus(delete_id).then(data => {
            dispatch('alert/success', 'Delete data Successfully', { root: true });
            commit('ShowAdd', data);
            RunningTextService.list().then(data => {
                commit('addData', data);
            }, error => {
                console.log(error);
            });
        }, error => {
            dispatch('alert/error', error, { root: true });
        })
    },
}
const mutations = {
    resetList(state){
      state.list = [];
    },
    setloading(state) {
        state.loading = true
    },
    ShowAdd(state, data) {
        console.log(data);
        state.dialog = false;
    },
    addData(state, apps) {
        state.list = []
        state.list = apps.data.content;
        state.loading = false;
        state.dialog = false;
    },
    opendialog(state) {
        state.dialog = true
    },
    closedialog(state) {
        state.dialog = false
    }
}

export const RunningText = {
    namespaced: true,
    state,
    actions,
    mutations
};
